import type { DocumentReadiness } from "@tc/shared";
import type { DocStatus, IconName } from "@/components/ui";

/** How each derived document-readiness maps onto a chip variant, icon and i18n label key. */
export const READINESS: Record<
  DocumentReadiness,
  { chip: DocStatus; icon: IconName; key: string }
> = {
  ok: { chip: "ok", icon: "check", key: "roster.docOk" },
  expiring: { chip: "warn", icon: "alert", key: "roster.docExpiring" },
  expired: { chip: "expired", icon: "alert", key: "roster.docExpired" },
  missing: { chip: "missing", icon: "alert", key: "roster.docMissing" },
};
